<template>
    <div class="rank">
<!--        <img-->
<!--            v-if="type !== 'academy'"-->
<!--            class="top"-->
<!--            src="@/assets/message/img.png"-->
<!--            alt=""-->
<!--        />-->
        <div class="bottom">
            <div class="category">
                <div class="border"></div>
                <div class="font">{{ category }}</div>
            </div>
            <div class="ranking">
                <div class="list" v-for="(item, index) in schools" :key="index" @click="school_info(item)">
                    <div class="num">{{ index + 1 }}</div>
                    <div class="text">{{ item.name }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        category: {
            typeof: String,
            default: "测试",
        },
        schools: {
            typeof: Array,
            default: [],
        },
        type: {
            typeof: String,
            default: "rank",
        },
    },
    methods: {
        school_info(item) {
            let routeData = this.$router.resolve({
                path: '/school_info',
                query: {school_id: item.school_id, school_name: item.name, from: 1}
            })
            window.open(routeData.href, '_blank');
        }
    }
};
</script>

<style lang="scss" scoped>

.rank {
    width: 300px;
    margin-left: 20px;
}

.top {
    width: 100%;
    height: 167px;
    border-radius: 6px;
}

.bottom {
    width: calc(100% - 40px);
    padding: 20px;
    background: var(--sub-bg);
    border-radius: 6px;
    margin-top: 10px;
    
    .category {
        font-weight: 700;
        height: 45px;
        line-height: 45px;
        
        .font {
            font-size: 24px;
        }
    }
    
    .ranking {
        margin-top: 20px;
        width: 100%;
        
        .list {
            width: 100%;
            display: flex;
            align-items: center;
            margin-bottom: 15px;
            cursor: pointer;
            
            &:nth-of-type(-n + 3) {
                .num {
                    color: #fff;
                    background: linear-gradient(132.51deg, #e93a29 3.99%, #ef6830 100%);
                }
            }
            
            &:hover {
                .text {
                    color: #ef6830;
                }
            }
            
            .num {
                width: 18px;
                height: 18px;
                background: #dfdfdf;
                font-size: 12px;
                text-align: center;
                line-height: 18px;
                border-radius: 4px;
                color: var(--font-3);
                margin-right: 10px;
            }
            
            .text {
                color: var(--font-1);
                font-style: 16px;
                white-space: nowrap; //不换行
                overflow: hidden; //超出隐藏
                text-overflow: ellipsis //超出文本省略号;
            }
        }
    }
    
    .school {
        width: 100%;
        margin-top: 20px;
        
        .list {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            
            .list_left {
                width: 52px;
                height: 52px;
                margin-right: 10px;
            }
            
            .list_right {
                display: flex;
                flex-direction: column;
                justify-content: center;
                
                .list_name {
                    color: var(--font-1);
                    font-size: 16px;
                    font-weight: 500;
                }
                
                .list_tip {
                    font-size: 12px;
                    margin-top: 5px;
                    color: var(--font-2);
                }
            }
        }
    }
    
    .academy {
        width: 100%;
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        
        .list {
            width: 72px;
            padding-left: 10px;
            height: 64px;
            // background: var(--main-bg);
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-bottom: 10px;
            border-radius: 6px;
            
            .list_top {
                color: var(--primary);
                font-size: 24px;
                font-weight: 700;
                
                span {
                    font-size: 14px;
                    font-weight: 400;
                    margin-left: 2px;
                }
            }
            
            .list_bottom {
                font-size: 14px;
                color: var(--font-1);
            }
        }
    }
}
</style>